export const COMMON_ERROR = {
  SUCCESS: {
    errorCode: 1,
    message: "Success",
    name: "SUCCESSFUL",
  },
  NOT_FOUND: {
    errorCode: 4,
    message: "Serial number not available",
    name: "NOT_FOUND",
  },
};
